// extracted by mini-css-extract-plugin
export var modal = "_br-0";